
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:root{
--sic-cta--default--text-color:var(--color-primary-default);
--sic-cta--default--font-size:var(--body-helper-font-size);
--sic-cta--default--font-size--sm-locked:calc(var(--body-helper-min-font-size));
--sic-cta--default--font-size--lg:var(--body-01-font-size);
--sic-cta--default--line-height:var(--line-height-xl);
--sic-cta--default--family:var(--ff-body);
--sic-cta--default--weight:var(--fw-bold);
--sic-cta--default--padding:var(--spacing-01) 0;
--sic-cta--default--margin:0 var(--spacing-01) 0 0;
--sic-cta--default--radius:var(--border-radius-outline-default);
--sic-cta--default--border-color:var(--color-primary-default);
--sic-cta--default--border-width:var(--border-width-thicker);
--sic-cta--file-icon-size:var(--spacing-04);
--sic-cta--default--outline-width--focus:var(--border-width-thicker);
--sic-cta--default--outline-offset--focus:var(--border-width-thicker);
--sic-cta--default--text-color--disabled:var(--color-neutral-light);
}

sic-cta a.sic-cta,
sic-cta button.sic-cta{
  color:var(--sic-cta--text-color, var(--sic-cta--default--text-color));
  font-size:var(--sic-cta--font-size, var(--sic-cta--default--font-size));
  font-weight:var(--sic-cta--weight, var(--sic-cta--default--weight));
  line-height:var(
    --sic-cta--line-height,
    var(--sic-cta--default--line-height)
  );
  text-decoration:none;
  padding:var(--sic-cta--padding, var(--sic-cta--default--padding));
  margin:var(--sic-cta--margin, var(--sic-cta--default--margin));
  cursor:pointer;
  background-image:linear-gradient(
    transparent calc(100% - 2px),
    var(--sic-cta--text-color, var(--sic-cta--default--text-color)) 2px
  );
  background-repeat:no-repeat;
  background-size:0 100%;
  transition:background-size var(--duration-slowly);
  display:inline !important;
}

@media (prefers-reduced-motion: no-preference){

sic-cta a.sic-cta,
sic-cta button.sic-cta{
    transition:all var(--duration-quickly)
}
  }

sic-cta a.sic-cta:hover, sic-cta button.sic-cta:hover{
    background-size:100% 100%;
  }

sic-cta a.sic-cta:hover,
  sic-cta a.sic-cta:focus,
  sic-cta button.sic-cta:hover,
  sic-cta button.sic-cta:focus{
    text-decoration:none;
    background-color:transparent;
    color:var(--sic-cta--text-color, var(--sic-cta--default--text-color));
  }

sic-cta a.sic-cta:focus, sic-cta button.sic-cta:focus{
    border-radius:var(--sic-cta--radius, var(--sic-cta--default--radius));
    outline-color:var(
      --sic-cta--outline-color,
      var(--sic-cta--default--outline-color--focus)
    );
    outline-style:solid;
    outline-width:var(
      --sic-cta--outline-width,
      var(--sic-cta--default--outline-width--focus)
    );
    outline-offset:var(
      --sic-cta--outline-offset,
      var(--sic-cta--default--outline-offset--focus)
    );
  }

sic-cta a.sic-cta.lg, sic-cta button.sic-cta.lg{
    font-size:var(
      --sic-cta--font-size--lg,
      var(--sic-cta--default--font-size--lg)
    );
  }

sic-cta a.sic-cta.sm-locked, sic-cta button.sic-cta.sm-locked{
    font-size:var(
      --sic-cta--font-size--sm-locked,
      var(--sic-cta--default--font-size--sm-locked)
    );
  }

sic-cta a.sic-cta.sm-locked .last-word::after,
    sic-cta a.sic-cta.sm-locked.icon-default .last-word::after,
    sic-cta button.sic-cta.sm-locked .last-word::after,
    sic-cta button.sic-cta.sm-locked.icon-default .last-word::after{
      height:var(--spacing-04);
      width:var(--spacing-04);
    }

sic-cta a.sic-cta.multi-line, sic-cta button.sic-cta.multi-line{
    display:inline;
    white-space:normal;
  }

sic-cta a.sic-cta.multi-line::after, sic-cta button.sic-cta.multi-line::after{
      margin-bottom:calc(-1 * var(--spacing-01));
    }

sic-cta a.sic-cta .last-word, sic-cta button.sic-cta .last-word{
    display:inline-flex;
    align-items:center;
    text-decoration:none;
    pointer-events:none;
  }

sic-cta a.sic-cta .last-word::after, sic-cta button.sic-cta .last-word::after{
      content:'';
      display:inline-block;
      margin-left:calc(var(--spacing-03));
      background-size:contain;
      background-position:left center;
      background-repeat:no-repeat;
    }

sic-cta a.sic-cta .last-word sup, sic-cta button.sic-cta .last-word sup{
      top:-0.5em;
    }

sic-cta a.sic-cta .last-word sub, sic-cta button.sic-cta .last-word sub{
      top:0.5em;
    }

sic-cta a.sic-cta .last-word::after,
  sic-cta a.sic-cta.icon-default .last-word::after,
  sic-cta button.sic-cta .last-word::after,
  sic-cta button.sic-cta.icon-default .last-word::after{
    background-image:var(
      --sic-cta--icon,
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23004EA8' viewBox='0 0 320 512'%3E%3Cpath d='M285.476 272.971 91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z'/%3E%3C/svg%3E")
    );
    height:var(--spacing-05);
    width:var(--spacing-05);
  }

@media (prefers-reduced-motion: no-preference){

sic-cta a.sic-cta .last-word::after,
  sic-cta a.sic-cta.icon-default .last-word::after,
  sic-cta button.sic-cta .last-word::after,
  sic-cta button.sic-cta.icon-default .last-word::after{
      transition:all var(--duration-slowly)
  }
    }

sic-cta a.sic-cta.icon-default:hover .last-word::after, sic-cta a.sic-cta.icon-default:focus .last-word::after, sic-cta a.sic-cta:hover .last-word::after, sic-cta a.sic-cta:focus .last-word::after, sic-cta button.sic-cta.icon-default:hover .last-word::after, sic-cta button.sic-cta.icon-default:focus .last-word::after, sic-cta button.sic-cta:hover .last-word::after, sic-cta button.sic-cta:focus .last-word::after{
      transform:translateX(calc(var(--spacing-02)));
    }

sic-cta a.sic-cta.file-link::before, sic-cta a.sic-cta.pdf-link::before, sic-cta a.sic-cta.ppt-link::before, sic-cta button.sic-cta.file-link::before, sic-cta button.sic-cta.pdf-link::before, sic-cta button.sic-cta.ppt-link::before{
      content:'';
      background-size:100% 100%;
      display:inline-block;
      margin-right:calc(var(--spacing-02));
      transform:translateY(2px);
      height:var(--spacing-05);
      width:var(--spacing-05);
    }

sic-cta a.sic-cta.pdf-link::before, sic-cta button.sic-cta.pdf-link::before{
    background-image:var(
      --sic-cta--icon-pdf,
      url('data:image/svg+xml,<svg width="18" height="25" viewBox="0 0 18 25" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(%23clip0_12469_7225)"><path d="M3 0.5C1.34531 0.5 0 1.84531 0 3.5V21.5C0 23.1547 1.34531 24.5 3 24.5H15C16.6547 24.5 18 23.1547 18 21.5V8H12C11.1703 8 10.5 7.32969 10.5 6.5V0.5H3ZM12 0.5V6.5H18L12 0.5ZM3 11H4.125C5.57344 11 6.75 12.1766 6.75 13.625C6.75 15.0734 5.57344 16.25 4.125 16.25H3.75V17.75C3.75 18.1625 3.4125 18.5 3 18.5C2.5875 18.5 2.25 18.1625 2.25 17.75V15.5V11.75C2.25 11.3375 2.5875 11 3 11ZM4.125 14.75C4.74844 14.75 5.25 14.2484 5.25 13.625C5.25 13.0016 4.74844 12.5 4.125 12.5H3.75V14.75H4.125ZM7.5 11.75C7.5 11.3375 7.8375 11 8.25 11H9.375C10.6172 11 11.625 12.0078 11.625 13.25V16.25C11.625 17.4922 10.6172 18.5 9.375 18.5H8.25C7.8375 18.5 7.5 18.1625 7.5 17.75V11.75ZM9 17H9.375C9.7875 17 10.125 16.6625 10.125 16.25V13.25C10.125 12.8375 9.7875 12.5 9.375 12.5H9V17ZM13.5 11H15.75C16.1625 11 16.5 11.3375 16.5 11.75C16.5 12.1625 16.1625 12.5 15.75 12.5H14.25V14H15.75C16.1625 14 16.5 14.3375 16.5 14.75C16.5 15.1625 16.1625 15.5 15.75 15.5H14.25V17.75C14.25 18.1625 13.9125 18.5 13.5 18.5C13.0875 18.5 12.75 18.1625 12.75 17.75V14.75V11.75C12.75 11.3375 13.0875 11 13.5 11Z" fill="%23004EA8"/></g><defs><clipPath id="clip0_12469_7225"><rect width="18" height="24" fill="white" transform="translate(0 0.5)"/></clipPath></defs></svg>')
    );
  }

sic-cta a.sic-cta.file-link::before, sic-cta button.sic-cta.file-link::before{
    background-image:var(
      --sic-cta--icon-file,
      url('data:image/svg+xml,<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(%23clip0_3916_156398)"><g clip-path="url(%23clip1_3916_156398)"><path d="M6 0.5C4.34531 0.5 3 1.84531 3 3.5V21.5C3 23.1547 4.34531 24.5 6 24.5H18C19.6547 24.5 21 23.1547 21 21.5V8H15C14.1703 8 13.5 7.32969 13.5 6.5V0.5H6ZM15 0.5V6.5H21L15 0.5ZM8.25 12.5H15.75C16.1625 12.5 16.5 12.8375 16.5 13.25C16.5 13.6625 16.1625 14 15.75 14H8.25C7.8375 14 7.5 13.6625 7.5 13.25C7.5 12.8375 7.8375 12.5 8.25 12.5ZM8.25 15.5H15.75C16.1625 15.5 16.5 15.8375 16.5 16.25C16.5 16.6625 16.1625 17 15.75 17H8.25C7.8375 17 7.5 16.6625 7.5 16.25C7.5 15.8375 7.8375 15.5 8.25 15.5ZM8.25 18.5H15.75C16.1625 18.5 16.5 18.8375 16.5 19.25C16.5 19.6625 16.1625 20 15.75 20H8.25C7.8375 20 7.5 19.6625 7.5 19.25C7.5 18.8375 7.8375 18.5 8.25 18.5Z" fill="%23004EA8"/></g></g><defs><clipPath id="clip0_3916_156398"><rect width="24" height="24" fill="white" transform="translate(0 0.5)"/></clipPath><clipPath id="clip1_3916_156398"><rect width="18" height="24" fill="white" transform="translate(3 0.5)"/></clipPath></defs></svg>')
    );
  }

sic-cta a.sic-cta.ppt-link::before, sic-cta button.sic-cta.ppt-link::before{
    background-image:var(
      --sic-link--icon-ppt,
      url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM136 240h68c42 0 76 34 76 76s-34 76-76 76H160v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V368 264c0-13.3 10.7-24 24-24zm68 104c15.5 0 28-12.5 28-28s-12.5-28-28-28H160v56h44z" fill="%23004EA8"/></svg>')
    );
  }

sic-cta a.sic-cta[target='_blank'] .last-word::after, sic-cta a.sic-cta.icon-external .last-word::after, sic-cta button.sic-cta[target='_blank'] .last-word::after, sic-cta button.sic-cta.icon-external .last-word::after{
      background-image:var(
        --sic-cta--icon-external,
        url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 25'%3E%3Cg clip-path='url(%23a)'%3E%3Cpath fill='%23004EA8' fill-rule='evenodd' d='M20.25 15.824h-1.5a.739.739 0 0 0-.75.727v5.086H3V7.105h6.75c.414 0 .75-.325.75-.726V4.926a.739.739 0 0 0-.75-.727h-7.5C1.007 4.2 0 5.175 0 6.38v15.984c0 1.204 1.007 2.18 2.25 2.18h16.5c1.243 0 2.25-.976 2.25-2.18v-5.812a.739.739 0 0 0-.75-.727Zm2-14.531h-7.438c-.724 0-1.312.57-1.312 1.271v.85c.01.337.158.657.41.888.254.232.592.356.94.347L18 4.562 6.331 15.783l-.003.004a1.066 1.066 0 0 0 0 1.54L7.45 18.41l.003.003c.44.423 1.152.421 1.59-.004L20.625 7.105l-.088 3.052v.035c0 .703.588 1.272 1.312 1.272h.838c.725 0 1.313-.57 1.313-1.272V2.988c0-.936-.783-1.695-1.75-1.695Z' clip-rule='evenodd'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath fill='%23fff' d='M0 .5h24v24H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E")
      );

      height:var(--spacing-04);
      width:var(--spacing-04);
      margin-right:0;
      transform:translateX(-2px) translateY(-1px);
    }

sic-cta a.sic-cta[target='_blank']:hover .last-word::after, sic-cta a.sic-cta[target='_blank']:focus .last-word::after, sic-cta a.sic-cta.icon-external:hover .last-word::after, sic-cta a.sic-cta.icon-external:focus .last-word::after, sic-cta button.sic-cta[target='_blank']:hover .last-word::after, sic-cta button.sic-cta[target='_blank']:focus .last-word::after, sic-cta button.sic-cta.icon-external:hover .last-word::after, sic-cta button.sic-cta.icon-external:focus .last-word::after{
      transform:translateX(-2px) translateY(-1px);
    }

sic-cta a.sic-cta[aria-disabled='true']{
  color:var(
    --sic-cta--text-color--disabled,
    var(--sic-cta--default--text-color--disabled)
  );
  cursor:not-allowed;
  pointer-events:none;
  -webkit-user-select:none;
          user-select:none;
}

sic-cta a.sic-cta[aria-disabled='true']::after{
  background-image:var(
    --sic-cta--icon,
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23767676' viewBox='0 0 320 512'%3E%3Cpath d='M285.476 272.971 91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z'/%3E%3C/svg%3E")
  );
}

sic-cta a.sic-cta[target='_blank'][aria-disabled='true'] .last-word::after, sic-cta a.sic-cta.icon-external[aria-disabled='true'] .last-word::after{
    background-image:var(
      --sic-cta--icon-external,
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 25'%3E%3Cg clip-path='url(%23a)'%3E%3Cpath  fill='%23767676' fill-rule='evenodd' d='M20.25 15.824h-1.5a.739.739 0 0 0-.75.727v5.086H3V7.105h6.75c.414 0 .75-.325.75-.726V4.926a.739.739 0 0 0-.75-.727h-7.5C1.007 4.2 0 5.175 0 6.38v15.984c0 1.204 1.007 2.18 2.25 2.18h16.5c1.243 0 2.25-.976 2.25-2.18v-5.812a.739.739 0 0 0-.75-.727Zm2-14.531h-7.438c-.724 0-1.312.57-1.312 1.271v.85c.01.337.158.657.41.888.254.232.592.356.94.347L18 4.562 6.331 15.783l-.003.004a1.066 1.066 0 0 0 0 1.54L7.45 18.41l.003.003c.44.423 1.152.421 1.59-.004L20.625 7.105l-.088 3.052v.035c0 .703.588 1.272 1.312 1.272h.838c.725 0 1.313-.57 1.313-1.272V2.988c0-.936-.783-1.695-1.75-1.695Z' clip-rule='evenodd'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath fill='%23fff' d='M0 .5h24v24H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E")
    );
  }
`;